import { AdapterRegistry } from 'app/model/adapters/adapter-registry';
import { Model } from 'app/model/backendmodel';
import { Metamodel } from 'app/model/base/model';
import { TabularTypeDatasetAdapter, tabularPropertiesCommonAdapts } from './tabular-type.dataset.adapter';
import { MongoDbDataset } from 'app/model/dataset/mongo-db.dataset';

@AdapterRegistry.adapter({
    model: Metamodel.modelFor(MongoDbDataset),
    asynchronous: true,
    adapts: {
        name: '*',
        properties: {
            ...tabularPropertiesCommonAdapts,
            typeProperties: {
                collectionName: '*'
            }
        }
    }
})
export class MongoDbDatasetAdapter extends TabularTypeDatasetAdapter<MongoDbDataset, Model.DatasetResource> {
    protected async _toResource(dataset: MongoDbDataset): Promise<Model.DatasetResource> {
        return await this._toResourceInternal(dataset, Metamodel.modelFor(MongoDbDataset).name, 'collectionName');
    }

    protected async _toModel(modelDatasetResource: Model.DatasetResource, dataset?: MongoDbDataset): Promise<MongoDbDataset> {
        return await this._toModelInternal(modelDatasetResource, dataset, MongoDbDataset.MODEL, 'collectionName');
    }
}
